import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { toast } from "react-toastify";
import { AUTH_TOKEN } from "../../constants";
import { getTenantSubdomain, isAutoServicesTenant } from "../../utils/tenantBranding";

const baseURL = process.env.REACT_APP_BASE_URL;
const apiPort = process.env.REACT_APP_API_PROTOCOL;

/** Tenants where a 401 on an API call should not wipe localStorage (e.g. wrong password on login). */
function skipAggressiveLogoutOnAuthError(tenant: string): boolean {
  return (
    tenant === "ercs" ||
    tenant === "eurorepar" ||
    tenant === "www" ||
    isAutoServicesTenant(tenant)
  );
}

export const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args: any, api: any, extraOptions: any) => {
  const tenant = getTenantSubdomain();

  const fullBaseUrl = `${apiPort}://${tenant}.${baseURL}`;

  const rawBaseQuery = fetchBaseQuery({
    baseUrl: fullBaseUrl,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });

  const result = await rawBaseQuery(args, api, extraOptions);

  if (result?.error) {
    const status = result?.meta?.response?.status;

    if (status === 401) {
      toast.error("Session Expired");
      if (!skipAggressiveLogoutOnAuthError(tenant)) {
        localStorage.clear();
        window.location.replace("/");
      }
    }
    else if (status === 403) {
      const teamNotFound = result?.error?.data?.["detail"];
      if (teamNotFound === "Authentication credentials were not provided.") {
        toast.error("Session Expired");
        if (!skipAggressiveLogoutOnAuthError(tenant)) {
          localStorage.clear();
          window.location.replace("/");
        }
      } else {
      }
    }
    else if (status === 500) {
      // toast.error("Something went wrong!");
    } else {
    }
  }

  return result;
};